import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Helper from "../../../Helper";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import { getTrans as t } from "../../../Localization/translations";
import lineOfBusinessService from "../../../services/company/lineofbusinessService";
import subcompanyService from "../../../services/company/subcompanyService";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import CloseIcon from '@material-ui/icons/Close';
import Select from "react-select";






const DetailIncomeStatement = () => {
    const tableRef = useRef();
    const date = new Date();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [state1, setState] = useState({ isPaneOpen: false });
    const [subcompany, setSubcompany] = useState("");
    const [lineOfBusiness, setLineOfBusiness] = useState("");


    const [subcompanyOptions, setSubcompanyOptions] = useState([]);
    const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

    const today = new Date();

    const defaultFrom = new Date(today.getFullYear(), 0, 1);

    const [fromDate, setFromDate] = useState(defaultFrom);
    const [toDate, setToDate] = useState(today);

    const [rangeLabel, setRangeLabel] = useState("");

    const ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
        ],
        "Last Year": [
            moment().subtract(1, "year").startOf("year"),
            moment().subtract(1, "year").endOf("year"),
        ],
    };


    const handleDateRange = (event, picker) => {
        setCurrFrom(picker.startDate.toDate());
        setCurrTo(picker.endDate.toDate());
        setRangeLabel(
            `${picker.startDate.format("MM/DD/YYYY")} - ${picker.endDate.format(
                "MM/DD/YYYY"
            )}`
        );
    };

    const handlePeriod1Range = (event, picker) => {
        setP1From(picker.startDate.toDate());
        setP1To(picker.endDate.toDate());
    };

    const handlePeriod2Range = (event, picker) => {
        setP2From(picker.startDate.toDate());
        setP2To(picker.endDate.toDate());
    };


    const handleAccountClick = (accountCode) => {
        navigate("/reports", {
            state: {
                report: "accounting",
                viewAccounting: "accountentries",
                accountCode: accountCode,
                startDate: currFrom,
                endDate: currTo
            },
        });
    };

    // ytd | prevYtd | currMonth | prevMonth1 | prevMonth2

    /* ================= DATE CALCULATION ================= */

    const currentDateObj = new Date();
    const year = currentDateObj.getFullYear();
    const month = currentDateObj.getMonth();

    const ytdFromObj = new Date(year, 0, 1);
    const ytdToObj = new Date();
    const ytdText = `${Helper.Dateview(ytdFromObj)} to ${Helper.Dateview(ytdToObj)}`;

    const prevYtdFromObj = new Date(year - 1, 0, 1);
    const prevYtdToObj = new Date();
    prevYtdToObj.setFullYear(year - 1);
    const prevYtdText = `${Helper.Dateview(prevYtdFromObj)} to ${Helper.Dateview(prevYtdToObj)}`;

    const currMonthFromObj = new Date(year, month, 1);
    const currMonthToObj = new Date();
    const currMonthText = `${Helper.Dateview(currMonthFromObj)} to ${Helper.Dateview(currMonthToObj)}`;

    const prevMonth1FromObj = new Date(year, month - 1, 1);
    const prevMonth1ToObj = new Date();
    prevMonth1ToObj.setMonth(month - 1);
    const prevMonth1Text = `${Helper.Dateview(prevMonth1FromObj)} to ${Helper.Dateview(prevMonth1ToObj)}`;

    const prevMonth2FromObj = new Date(year, month - 2, 1);
    const prevMonth2ToObj = new Date();
    prevMonth2ToObj.setMonth(month - 2);
    const prevMonth2Text = `${Helper.Dateview(prevMonth2FromObj)} to ${Helper.Dateview(prevMonth2ToObj)}`;


    // current period
    const [currFrom, setCurrFrom] = useState(defaultFrom);
    const [currTo, setCurrTo] = useState(today);

    // period 1
    const [p1From, setP1From] = useState(null);
    const [p1To, setP1To] = useState(null);

    // period 2
    const [p2From, setP2From] = useState(null);
    const [p2To, setP2To] = useState(null);

    const [selectedContract, setSelectedContract] = useState(null);
    const [contractOptions, setContractOptions] = useState([]);
    const [contractInput, setContractInput] = useState("");
    const [contractPage, setContractPage] = useState(1);
    const [contractLoading, setContractLoading] = useState(false);




    // const getCalculatedFromTo = () => {
    //   if (compareMode === "ytd") return { from: ytdFromObj, to: ytdToObj };
    //   if (compareMode === "prevYtd") return { from: prevYtdFromObj, to: prevYtdToObj };
    //   if (compareMode === "currMonth") return { from: currMonthFromObj, to: currMonthToObj };
    //   if (compareMode === "prevMonth1") return { from: prevMonth1FromObj, to: prevMonth1ToObj };
    //   if (compareMode === "prevMonth2") return { from: prevMonth2FromObj, to: prevMonth2ToObj };
    //   return { from: ytdFromObj, to: ytdToObj }; // default
    // };


    const buildRanges = () => {
        const baseTo = toDate || new Date();
        const year = baseTo.getFullYear();
        const month = baseTo.getMonth();

        return {
            ytd: {
                from: new Date(year, 0, 1),
                to: baseTo,
            },

            prevYtd: {
                from: new Date(year - 1, 0, 1),
                to: new Date(baseTo.getFullYear() - 1, baseTo.getMonth(), baseTo.getDate()),
            },

            currMonth: {
                from: new Date(year, month, 1),
                to: baseTo,
            },

            prevMonth: {
                from: new Date(year, month - 1, 1),
                to: new Date(year, month, 0),
            },

            prevMonth2: {
                from: new Date(year, month - 2, 1),
                to: new Date(year, month - 1, 0),
            },
        };
    };


    /* ================= FETCH FILTER OPTIONS ================= */

    useEffect(() => {
        subcompanyService.getSubcompany().then((res) => {
            setSubcompanyOptions(res.data || []);
        });

        lineOfBusinessService.getLineOfBusiness().then((res) => {
            setLineOfBusinessOptions(res.data || []);
        });
    }, []);


    const loadContracts = async (value, page) => {
        try {
            if (!value) return;

            setContractLoading(true);

            const res = await fetch(
                `${API}contracts/contracts/filter/?id=${value}&page=${page}`,
                { headers: authHeader() }
            );

            const data = await res.json();

            if (data?.data?.length > 0) {
                setContractOptions((prev) => [...prev, ...data.data]);
                setContractPage((prev) => prev + 1);
            }

            setContractLoading(false);
        } catch (err) {
            console.error("Contract load error:", err);
            setContractLoading(false);
        }
    };

    const handleContractInputChange = (value, action) => {
        if (action.action === "input-change") {
            setContractInput(value);
            setContractPage(1);
            setContractOptions([]);
            loadContracts(value, 1);
        }
    };

    const handleContractScroll = () => {
        loadContracts(contractInput, contractPage);
    };

    const handleContractChange = (value) => {
        setSelectedContract(value);
    };


    /* ================= FETCH INCOME STATEMENT ================= */
    const buildParams = () => {
        const p = new URLSearchParams();

        // current period
        if (currFrom && currTo) {
            p.append("curr_from", Helper.DatePicker(currFrom));
            p.append("curr_to", Helper.DatePicker(currTo));
        }

        // period 1
        if (p1From && p1To) {
            p.append("p1_from", Helper.DatePicker(p1From));
            p.append("p1_to", Helper.DatePicker(p1To));
        }

        // period 2
        if (p2From && p2To) {
            p.append("p2_from", Helper.DatePicker(p2From));
            p.append("p2_to", Helper.DatePicker(p2To));
        }

        if (subcompany)
            p.append("subcompany", subcompany);

        if (lineOfBusiness)
            p.append("line_of_business", lineOfBusiness);

        if (selectedContract)
            p.append("contract_number", selectedContract.id);

        return p.toString();
    };

    const fetchIncomeStatement = async () => {
        setLoading(true);

        try {
            const res = await axios.get(
                `${API}accounting/income-statement/?${buildParams()}`,
                { headers: authHeader() }
            );

            setData(res.data);

        } catch (err) {
            console.error("Income statement error:", err);
        } finally {
            setLoading(false);
        }
    };



    /* Re-fetch when mode or filters change */
    useEffect(() => {
        fetchIncomeStatement();
    }, [
        currFrom,
        currTo,
        p1From,
        p1To,
        p2From,
        p2To,
        subcompany,
        lineOfBusiness,
        selectedContract
    ]);


    /* ================= BUILD TABLE ROWS ================= */

    const buildRows = () => {
        if (!data) return [];

        const rows = [];

        const mergeSection = (title, key) => {

            const current = data.current?.[key] || [];
            const period1 = data.period1?.[key] || [];
            const period2 = data.period2?.[key] || [];

            // ===== CLASS HEADER =====
            rows.push({
                account: title,
                current: "",
                period1: "",
                period2: "",
                isHeader: true,
            });

            current.forEach((subclassItem, i) => {

                // ===== SUBCLASS HEADER =====
                rows.push({
                    account: `   ${subclassItem.name}`,
                    current: "",
                    period1: "",
                    period2: "",
                    isSubHeader: true,
                });

                // ===== ACCOUNT LEVEL =====
                subclassItem.accounts.forEach((acc, accIndex) => {
                    rows.push({
                        account: `      ${acc.code} - ${acc.number}`,
                        account_code: acc.code,
                        isClickable: true,

                        current: Helper.Amount(acc.amount),

                        period1: p1From
                            ? Helper.Amount(
                                period1[i]?.accounts?.[accIndex]?.amount || 0
                            )
                            : "",

                        period2: p2From
                            ? Helper.Amount(
                                period2[i]?.accounts?.[accIndex]?.amount || 0
                            )
                            : "",
                    });
                });

                // ===== SUBCLASS TOTAL =====
                rows.push({
                    account: `   Total ${subclassItem.name}`,

                    current: Helper.Amount(subclassItem.total),

                    period1: p1From
                        ? Helper.Amount(period1[i]?.total || 0)
                        : "",

                    period2: p2From
                        ? Helper.Amount(period2[i]?.total || 0)
                        : "",

                    isTotal: true,
                });
            });

            // ===== CLASS TOTAL =====
            rows.push({
                account: `Total ${title}`,

                current: Helper.Amount(data.current?.totals?.[key] || 0),

                period1: p1From
                    ? Helper.Amount(data.period1?.totals?.[key] || 0)
                    : "",

                period2: p2From
                    ? Helper.Amount(data.period2?.totals?.[key] || 0)
                    : "",

                isTotal: true,
            });
        };

        // ===== MERGE SECTIONS =====
        mergeSection("Income", "income");
        mergeSection("Expenses", "expenses");

        // ===== NET PROFIT =====
        rows.push({
            account: "Net Profit",

            current: Helper.Amount(data.current?.totals?.net_profit || 0),

            period1: p1From
                ? Helper.Amount(data.period1?.totals?.net_profit || 0)
                : "",

            period2: p2From
                ? Helper.Amount(data.period2?.totals?.net_profit || 0)
                : "",

            isTotal: true,
        });

        return rows;
    };


    /* ================= RENDER ================= */

    return (
        <div className="">
            <div className="container-fluid py-4 pt-2">
                <div className="row py-2 mt-2">
                    <ToastContainer />
                    <div className="col-md-12">
                        <div className=" mb-0">
                            <div className="body">
                                <div className="p-0">
                                    <MaterialTable
                                        tableRef={tableRef}
                                        style={{
                                            padding: "0.5rem 0.5rem",
                                            backgroundColor: "var(--bs-table-bg)",
                                            borderBottomWidth: "1px",
                                            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                        }}
                                        title={
                                            <h5 className="mb-0">
                                                {t("Income Statement Detail")} <br />
                                            </h5>
                                        }
                                        columns={[
                                            {
                                                title: <div>{t("Account Class")}</div>,
                                                field: "account",
                                                headerStyle: { fontWeight: "bold", textAlign: "left" },
                                                cellStyle: { fontSize: 12, textAlign: "left" },

                                                render: (rowData) => {
                                                    if (rowData.isClickable) {
                                                        return (
                                                            <span
                                                                style={{ color: "#007bff", cursor: "pointer" }}
                                                                onClick={() => handleAccountClick(rowData.account_code)}
                                                            >
                                                                {rowData.account}
                                                            </span>
                                                        );
                                                    }

                                                    return <span>{rowData.account}</span>;
                                                }
                                            },

                                            {
                                                title: (
                                                    <div className="text-end">
                                                        {t("Current Period")}
                                                        <div style={{ fontSize: 11, fontWeight: "normal" }}>
                                                            {currFrom && currTo
                                                                ? `${Helper.Dateview(currFrom)} - ${Helper.Dateview(currTo)}`
                                                                : ""}
                                                        </div>
                                                    </div>
                                                ),
                                                field: "current",
                                                headerStyle: { fontWeight: "bold", textAlign: "right" },
                                                cellStyle: { fontSize: 12, textAlign: "right" },
                                            },

                                            {
                                                title: (
                                                    <div className="text-end">
                                                        {t("Period 1")}
                                                        <div style={{ fontSize: 11, fontWeight: "normal" }}>
                                                            {p1From && p1To
                                                                ? `${Helper.Dateview(p1From)} - ${Helper.Dateview(p1To)}`
                                                                : ""}
                                                        </div>
                                                    </div>
                                                ),
                                                field: "period1",
                                                headerStyle: { fontWeight: "bold", textAlign: "right" },
                                                cellStyle: { fontSize: 12, textAlign: "right" },
                                            },

                                            {
                                                title: (
                                                    <div className="text-end">
                                                        {t("Period 2")}
                                                        <div style={{ fontSize: 11, fontWeight: "normal" }}>
                                                            {p2From && p2To
                                                                ? `${Helper.Dateview(p2From)} - ${Helper.Dateview(p2To)}`
                                                                : ""}
                                                        </div>
                                                    </div>
                                                ),
                                                field: "period2",
                                                headerStyle: { fontWeight: "bold", textAlign: "right" },
                                                cellStyle: { fontSize: 12, textAlign: "right" },
                                            },
                                        ]}

                                        data={buildRows()}
                                        components={{
                                            Toolbar: (props) => (
                                                <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                                    <MTableToolbar {...props} />
                                                    <span
                                                        onClick={() => setState({ isPaneOpen: true })}
                                                        style={{ cursor: "pointer", paddingRight: "10px" }}
                                                    >
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/static/images/ic-filter.svg"}
                                                            alt=""
                                                        />
                                                    </span>
                                                </div>
                                            ),
                                        }}
                                        options={{
                                            headerStyle: {
                                                backgroundColor: "white",
                                                color: "#245C7F",
                                                fontSize: 12,
                                                fontWeight: "bold",
                                            },

                                            // IMPORTANT: allow row colors to show properly
                                            bodyStyle: {
                                                backgroundColor: "transparent",
                                            },

                                            // ✅ ROW COLORS (zebra + headers + totals)
                                            rowStyle: (rowData, index) => {
                                                const zebraColor = index % 2 === 1 ? "#ffffff" : "#f5f6f8";

                                                if (rowData.isHeader) {
                                                    return {
                                                        backgroundColor: "#eef1f4",
                                                        fontWeight: "bold",
                                                    };
                                                }

                                                if (rowData.isSubHeader) {
                                                    return {
                                                        backgroundColor: zebraColor,
                                                        fontWeight: "bold",
                                                    };
                                                }

                                                if (rowData.isTotal) {
                                                    return {
                                                        backgroundColor: zebraColor,
                                                        fontWeight: "bold",
                                                    };
                                                }

                                                return {
                                                    backgroundColor: zebraColor,
                                                };
                                            },


                                            sorting: true,
                                            search: true,
                                            toolbar: true,

                                            // ❌ NO pagination
                                            paging: false,

                                            emptyRowsWhenPaging: false,

                                            exportAllData: true,
                                            exportButton: true,
                                            exportFileName: "IncomeStatement",

                                            // ✅ CSV EXPORT
                                            // ✅ CSV EXPORT — FIXED
                                            exportCsv: async (columns, data) => {
                                                try {
                                                    const visible = Helper.visibleColumn(columns);

                                                    const headerMap = {
                                                        account: "Account",
                                                        current: "Current Period",
                                                        period1: "Period 1",
                                                        period2: "Period 2",
                                                    };


                                                    const escapeCSV = (value) => {
                                                        if (value === null || value === undefined) return '""';
                                                        const str = String(value).replace(/"/g, '""');
                                                        return `"${str}"`;
                                                    };

                                                    const headers = visible.map(col =>
                                                        escapeCSV(headerMap[col.field] || col.field)
                                                    );

                                                    const rows = data.map(row =>
                                                        visible.map(col =>
                                                            escapeCSV(row[col.field])
                                                        )
                                                    );

                                                    const csv =
                                                        headers.join(",") +
                                                        "\n" +
                                                        rows.map(r => r.join(",")).join("\n");

                                                    const blob = new Blob([csv], {
                                                        type: "text/csv;charset=utf-8;",
                                                    });

                                                    const link = document.createElement("a");
                                                    link.href = URL.createObjectURL(blob);
                                                    link.download = "IncomeStatement.csv";

                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);

                                                } catch (error) {
                                                    console.error("CSV export error:", error);
                                                }
                                            },


                                            // ✅ PDF EXPORT
                                            exportPdf: async (columns, data) => {
                                                try {
                                                    const visible = Helper.visibleColumn(columns);
                                                    if (!data?.length) return;

                                                    // ✅ Proper multi-line headers
                                                    const headers = visible.map(col => {
                                                        const map = {
                                                            account: "Account Class",

                                                            ytd:
                                                                "Year To Date\n" +
                                                                ytdText,

                                                            prev_ytd:
                                                                "Previous Year To Date\n" +
                                                                prevYtdText,

                                                            curr_month:
                                                                "Current Month\n" +
                                                                currMonthText,

                                                            prev_month:
                                                                "Previous Month\n" +
                                                                prevMonth1Text,

                                                            prev_month2:
                                                                "Previous Month -2\n" +
                                                                prevMonth2Text,
                                                        };

                                                        return map[col.field] || col.field;
                                                    });

                                                    const body = data.map(row =>
                                                        visible.map(col => row[col.field] ?? "")
                                                    );

                                                    const doc = new jsPDF("l");

                                                    // ===== HEADER =====
                                                    doc.setFont("helvetica", "bold");
                                                    doc.setFontSize(16);
                                                    doc.text("Income Statement", 14, 10);

                                                    doc.setFontSize(11);
                                                    doc.setFont("helvetica", "normal");
                                                    doc.text(
                                                        `Generated: ${Helper.Dateview(new Date())}`,
                                                        14,
                                                        16
                                                    );

                                                    // ===== TABLE =====
                                                    autoTable(doc, {
                                                        head: [headers],
                                                        body,
                                                        startY: 22,

                                                        styles: {
                                                            fontSize: 8,
                                                            halign: "center", // default center
                                                        },

                                                        headStyles: {
                                                            halign: "center",
                                                            valign: "middle",
                                                            fontStyle: "bold",
                                                        },

                                                        // ✅ column-specific alignment
                                                        columnStyles: {
                                                            0: { halign: "left" }, // Account column
                                                            1: { halign: "center" },
                                                            2: { halign: "center" },
                                                            3: { halign: "center" },
                                                            4: { halign: "center" },
                                                            5: { halign: "center" },
                                                        },
                                                    });


                                                    doc.save("IncomeStatement.pdf");

                                                } catch (error) {
                                                    console.error("PDF export error:", error);
                                                }
                                            },



                                            actionsColumnIndex: -1,
                                            columnsButton: true,
                                        }}
                                        localization={{
                                            toolbar: { searchPlaceholder: t("Search Income Statement") },
                                        }}
                                    />
                                </div>
                            </div>

                            {/* FILTER PANEL */}
                            <SlidingPane
                                isOpen={state1.isPaneOpen}
                                title="Filter By"
                                onRequestClose={() => setState({ isPaneOpen: false })}
                            >
                                <div className="col-md-12">
                                    <label className="col-form-label">{t("Company")}</label>
                                    <select
                                        className="form-select"
                                        onChange={(e) => setSubcompany(e.target.value)}
                                    >
                                        <option value="">{t("Select Company")}</option>
                                        {subcompanyOptions.map((sub) => (
                                            <option key={sub.id} value={sub.id}>
                                                {sub.sub_company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">{t("Line of Business")}</label>
                                    <select
                                        className="form-select"
                                        onChange={(e) => setLineOfBusiness(e.target.value)}
                                    >
                                        <option value="">{t("Select Line of Business")}</option>
                                        {lineOfBusinessOptions.map((lob) => (
                                            <option key={lob.id} value={lob.id}>
                                                {lob.lob_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-12 mt-2">
                                    <label className="col-form-label">{t("Contract")}</label>

                                    <Select
                                        value={selectedContract}
                                        options={contractOptions}
                                        onChange={handleContractChange}
                                        onInputChange={handleContractInputChange}
                                        onMenuScrollToBottom={handleContractScroll}
                                        getOptionLabel={(e) => e.contract_number}
                                        getOptionValue={(e) => e.id}
                                        isLoading={contractLoading}
                                        placeholder="Search Contract..."
                                    />
                                </div>

                                <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                        {t("Current Period")}
                                    </label>

                                    <div className="col-lg-12 position-relative">
                                        <DateRangePicker
                                            initialSettings={{ ranges }}
                                            startDate={currFrom !== "" ? currFrom : ""}
                                            endDate={currTo !== "" ? currTo : ""}
                                            alwaysShowCalendars={true}
                                            onEvent={handleDateRange}
                                        >
                                            <div className="form-control d-flex justify-content-between align-items-center">
                                                <span>
                                                    {currFrom ? Helper.DateNormal(currFrom) : "Select Start Date"} to{" "}
                                                    {currTo ? Helper.DateNormal(currTo) : "Select End Date"}
                                                </span>
                                            </div>
                                        </DateRangePicker>


                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                        {t("Period 1")}
                                    </label>

                                    <div className="col-lg-12 position-relative">
                                        <DateRangePicker
                                            initialSettings={{ ranges }}
                                            startDate={p1From !== "" ? p1From : ""}
                                            endDate={p1To !== "" ? p1To : ""}
                                            alwaysShowCalendars={true}
                                            onEvent={handlePeriod1Range}
                                        >
                                            <div className="form-control d-flex justify-content-between align-items-center">
                                                <span>
                                                    {p1From ? Helper.DateNormal(p1From) : "Select Start Date"} to{" "}
                                                    {p1To ? Helper.DateNormal(p1To) : "Select End Date"}
                                                </span>
                                            </div>
                                        </DateRangePicker>


                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                        {t("Period 2")}
                                    </label>

                                    <div className="col-lg-12 position-relative">
                                        <DateRangePicker
                                            initialSettings={{ ranges }}
                                            startDate={p2From !== "" ? p2From : ""}
                                            endDate={p2To !== "" ? p2To : ""}
                                            alwaysShowCalendars={true}
                                            onEvent={handlePeriod2Range}
                                        >
                                            <div className="form-control d-flex justify-content-between align-items-center">
                                                <span>
                                                    {p2From ? Helper.DateNormal(p2From) : "Select Start Date"} to{" "}
                                                    {p2To ? Helper.DateNormal(p2To) : "Select End Date"}
                                                </span>
                                            </div>
                                        </DateRangePicker>

                                    </div>
                                </div>


                                {/* <div className="col-md-12 mt-2">
                  <label className="col-form-label">{t("Enter Date")}</label>
                  <DatePicker
                    className="form-control datepick"
                    selected={amountDate}
                    onChange={(date) => setAmountDate(date)}
                    name="date"
                    placeholderText={"mm/dd/yyyy"}
                    showYearDropdown
                    scrollableYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                  />
                </div> */}

                                {/* RADIO BUTTONS */}
                                {/* <div className="col-md-12 mt-3">
                  <label className="col-form-label fw-bold">Compare With</label>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="compareMode"
                      value="ytd"
                      checked={compareMode === "ytd"}
                      onChange={() => setCompareMode("ytd")}
                    />
                    <label className="form-check-label">Year To Date</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="compareMode"
                      value="prevYtd"
                      checked={compareMode === "prevYtd"}
                      onChange={() => setCompareMode("prevYtd")}
                    />
                    <label className="form-check-label">Previous Year To Date</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="compareMode"
                      value="currMonth"
                      checked={compareMode === "currMonth"}
                      onChange={() => setCompareMode("currMonth")}
                    />
                    <label className="form-check-label">Current Month</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="compareMode"
                      value="prevMonth1"
                      checked={compareMode === "prevMonth1"}
                      onChange={() => setCompareMode("prevMonth1")}
                    />
                    <label className="form-check-label">Previous Month</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="compareMode"
                      value="prevMonth2"
                      checked={compareMode === "prevMonth2"}
                      onChange={() => setCompareMode("prevMonth2")}
                    />
                    <label className="form-check-label">Previous Month -2</label>
                  </div>
                </div> */}

                                <div className="mt-4">
                                    <button
                                        className="btn bg-gradient-secondary"
                                        onClick={() => {
                                            // clear filters
                                            setSubcompany("");
                                            setLineOfBusiness("");
                                            setCurrFrom(defaultFrom);
                                            setCurrTo(today);
                                            setP1From(null);
                                            setP1To(null);
                                            setP2From(null);
                                            setP2To(null);
                                            setData(null);
                                            fetchIncomeStatement();
                                            setSelectedContract(null);
                                            setContractOptions([]);
                                            setContractInput("");
                                        }}
                                    >

                                        {t("Reset")}
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            fetchIncomeStatement();
                                            setState({ isPaneOpen: false });
                                        }}
                                    >
                                        {t("Apply")}
                                    </button>
                                </div>
                            </SlidingPane>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailIncomeStatement;